import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.tablaRelacional', {
    url: '/tablaRelacional?:empresa&:empleado',
    template,
    data: {
      title: 'Tabla relacional',
    },
    resolve: {
      Auth: (Permisos) => {
        return Permisos.modulos({
          editar: 'kendu.finanzas.tablaRelacional',
        })
      },
      Empleados: ($stateParams, $kardex) => {
        return $stateParams['empresa'] ? $kardex.$list($stateParams['empresa']) : undefined
      },
      Catalogos: ($catalogos, $session, Empleados) => {
        return $catalogos.$fetch().then(function (Catalogos) {
          return {
            Empleados: Empleados,
            Empresas: Catalogos.Empresas.$select(),
          }
        })
      },
      Data: ($stateParams, FinanzasTablaRelacional) => {
        var ID_Empresa = $stateParams['empresa']
        var ID_Empleado = $stateParams['empleado']
        return (ID_Empleado && ID_Empresa) ? FinanzasTablaRelacional.select(ID_Empleado, ID_Empresa)
          : undefined
      },
    },
    controllerAs: 'ctrl',
    controller (Data, Catalogos, $scope, $stateParams, $location, $dialog, FinanzasTablaRelacional) {
      var ctrl = this

      ctrl.data = Data
      ctrl.saving = false
      ctrl.options = {
        ID_Empresa: $stateParams['empresa'],
        ID_Empleado: $stateParams['empleado'],
      }
      ctrl.catalogos = Catalogos

      ctrl.set = function (ID_Relacional, Nombre_Largo, data) {
        $dialog.show('finances.tablaRelacional.set', {
          ID_Empresa: ctrl.options.ID_Empresa,
          ID_Empleado: ctrl.options.ID_Empleado,
          ID_Relacional: angular.isString(ID_Relacional) ? ID_Relacional : null,
          Nombre_Largo: angular.isString(Nombre_Largo) ? Nombre_Largo : null,
          data: angular.isObject(data) ? data : null,
        }).then(function (result) {
          if (data) {
            angular.extend(data, result)
          } else {
            ctrl.data.push(result)
          }
        })
      }

      ctrl.update = function (item) {
        ctrl.saving = true
        return FinanzasTablaRelacional.set(
          ctrl.options.ID_Empleado,
          ctrl.options.ID_Empresa,
          item.ID_Relacional,
          item.Nombre_Largo,
          item,
        ).finally(function () {
          ctrl.saving = false
        })
      }

      ctrl.remove = function (item) {
        ctrl.saving = true
        return FinanzasTablaRelacional.set(
          ctrl.options.ID_Empleado,
          ctrl.options.ID_Empresa,
          item.ID_Relacional,
          item.Nombre_Largo,
          null,
        ).then(function () {
          ctrl.data.splice(ctrl.data.indexOf(item), 1)
        }).finally(function () {
          ctrl.saving = false
        })
      }

      $scope.$watchGroup(['ctrl.options.ID_Empresa', 'ctrl.options.ID_Empleado'], function () {
        $location.search({
          empresa: ctrl.options.ID_Empresa,
          empleado: ctrl.options.ID_Empleado,
        })
      })
    },
  })
})






// WEBPACK FOOTER //
// ./src/finanzas/_/tablaRelacional/finances-tablaRelacional.js